<template>
  <div class="home">
    <Selector msg="Welcome to Estimation" />
  </div>
</template>

<script>
import axios from "axios";
// @ is an alias to /src
import Selector from "@/components/Selector.vue";

export default {
  name: "home",
  components: {
    Selector
  }
};
</script>
